import { API_ACTIONS, API_ENDPOINTS } from "constants/apiEndpoints";
import { API_METHODS, ENV_CONFIGS } from "constants/constants";
import { getUserToken } from "utils/commonMethods";

//Hits an api call.
function requestFetchApi(requestUrl, requestMethod, requestData) {
  return window
    .fetch(requestUrl, {
      method: requestMethod,
      headers: {
        "Content-Type": "application/json",
        Authorization: getUserToken(),
      },
      body: JSON.stringify(requestData),
    })
    .then((Data) =>
      Data.json().then((response) => {
        //If api response is fulfilled, resolve the promise. Otherwise reject.
        if (response.success) {
          return Promise.resolve(response.data);
        } else {
          return Promise.reject(response.message);
        }
      })
    );
}

//Hits an api call using post method.
export async function requestPostFetchApi(apiKey, apiData = {}) {
  let requestUrl = `${ENV_CONFIGS.API_ENDPOINT}/${API_ENDPOINTS[apiKey]}`;

  let requestData = {
    payload: { action: API_ACTIONS[apiKey], ...apiData },
  };

  return requestFetchApi(requestUrl, API_METHODS.POST, requestData);
}

//Hits an api call using post method.
export async function requestDispenseLaterPostFetchApi(apiKey, apiData = {}) {
  let requestUrl = `${ENV_CONFIGS.API_ENDPOINT}/${API_ENDPOINTS[apiKey]}`;

  let requestData = {
    payload: { action: API_ACTIONS[apiKey], ...apiData },
  };

  return requestDispenseLaterFetchApi(
    requestUrl,
    API_METHODS.POST,
    requestData
  );
}

//Hits an api call.
function requestDispenseLaterFetchApi(requestUrl, requestMethod, requestData) {
  return window
    .fetch(requestUrl, {
      method: requestMethod,
      headers: {
        "Content-Type": "application/json",
        Authorization: getUserToken(),
      },
      body: JSON.stringify(requestData),
    })
    .then((Data) =>
      Data.json().then((response) => {
        //If api response is fulfilled, resolve the promise. Otherwise reject.
        if (response.success) {
          return Promise.resolve(response);
        } else {
          return Promise.reject(response);
        }
      })
    );
}
